import {createStore} from 'vuex'

export default createStore({
    actions: {

        async fetchItems(context) {
            context.state.loadingMain = true;
            context.state.loadingDop = true;
            const res = await
                fetch(
                    "http://m9com.ru/wp-content/api24tv/getAllTV.php"
                );
            const posts = await res.json();
            context.commit('updateAllPosts', posts);

            context.state.loadingMain = false;


            context.state.loadingDop = false;



        },

    },
    state: {
        detailInfo: false,
        globalPacketName: {
            k: '',
            name: ''
        },
        allPosts: [],
        dopPosts: [],
        currentBox: {},
        channelsGrouped: [],
        filteredChannels: [],
        loading: false,
        loadingMain: false,
        loadingDop: false,
        isFilter: false,
        globalPacketId: '',
    },
    getters: {
        getAllPosts (state) {
            return state.allPosts
        },
        getDops (state) {
            return state.dopPosts
        },
        fChannels (state){
            return state.filteredChannels;
        },
        detailInfo(state) {
            return state.detailInfo;
        },
        getCurrentBox (state) {
            return state.currentBox;
        },
        getCurrentChannels (state) {
            if(state.channelsGrouped.length > 0)
                return state.channelsGrouped;
            else
                return 'Waiting';
        }
    },
    mutations: {
        async loadPacket(state) {
            let id = state.globalPacketId;
            state.detailInfo = true;
            state.loading = true;
            const res = await fetch(
                `http://m9com.ru/wp-content/api24tv/packetbyid.php?id=${id}`
            );
            let firstResp = await res.json();


            if(firstResp === null){
                state.loading = false;
                state.emptyBox = true;
            }
            else{
                state.currentBox = firstResp;

                const res2 = await fetch(
                    `http://m9com.ru/wp-content/api24tv/getChannels.php?id=${id}`
                );
                state.channelsGrouped = await res2.json();

                state.loading = false;
            }

        },
        filterCurrent (state, newState){
            // if(newState.el)
            // state.filteredChannels = newState.el;

            state.isFilter = newState.pos;
        },
        updateAllPosts(state, posts) {
            state.allPosts = posts
        },
        updateDops (state, posts) {
            state.dopPosts = posts
        },
        globalPacketName (state, name){
            state.globalPacketName.name = name.name;
            state.globalPacketName.k = name.kCOL;
        },
        globalPacketId (state, id){
            state.globalPacketId = id;
        },
        toggleDetailInfo(state, subBlock) {
            state.detailInfo = !state.detailInfo;

            if(!state.detailInfo){
                state.currentBox = {};
                state.channelsGrouped = [];
            }


        }
        ,
    },

    modules: {}
})
